import { Injectable, signal, computed } from '@angular/core';
import { Team } from '../../interfaces/database/team.interface';
import { TeamMockService } from './team-mock.service';

@Injectable({ providedIn: 'root' })
export class TeamContextService {

    private readonly _teams = signal<Team[]>([]);
    private readonly _selectedTeamId = signal<string>('padel-rangers');

    readonly availableTeams = this._teams.asReadonly();
    readonly selectedTeamId = this._selectedTeamId.asReadonly();

    readonly selectedTeam = computed(() =>
        this._teams().find(t => t.id === this._selectedTeamId()) ?? null
    );

    constructor(private _mock: TeamMockService) {
        this._teams.set(this._mock.getTeams());
    }

    selectTeam(id: string): void {
        const exists = this._teams().some(t => t.id === id);
        if (exists) this._selectedTeamId.set(id);
    }
}
